import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingSpinner } from "../components";
import { OpsType } from "../types";
import { useAuth } from "./AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
  requireOps?: OpsType;
  requireScreen?: string;
}

export function ProtectedRoute({
  children,
  requireOps,
  requireScreen,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, isGestor, hasOpsAccess, hasScreenAccess } =
    useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isGestor()) {
    return <Navigate to="/login" replace />;
  }

  if (requireOps && !hasOpsAccess(requireOps)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireScreen && !hasScreenAccess(requireScreen, requireOps)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
